import SubstituteScheduler, {
  SubstituteSchedulerLesson,
} from "../../../components/scheduler/SubstituteScheduler";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { Teacher } from "../../../models/teacher/teacher";
import { UseFormSetValue, useWatch } from "react-hook-form";
import VacancySubstituteSelectionCombobox from "../VacancySubstituteSelectionCombobox";
import { Schedule } from "../../../models/schedule/schedule";
import { VacancyFormFields } from "../VacancyCreateWizard";

function SubstitutesStep({
  control,
  setLessons,
  lessons,
  setValue,
  schedule,
}: FormWizardStepProps<VacancyFormFields> & {
  setLessons: (lessons: SubstituteSchedulerLesson[][]) => void;
  lessons: SubstituteSchedulerLesson[][];
  setValue: UseFormSetValue<VacancyFormFields>;
  schedule: Schedule;
}) {
  const dates = useWatch({ name: ["start", "end"], control });

  const substitutes = useWatch({ name: "substitutes", control });
  const absentTeacher = useWatch({ name: "teacher", control });

  const onSetSubstitutes = (value: Teacher[] | undefined) => {
    setValue("substitutes", value);

    setLessons(
      lessons.map((day) =>
        day.map((l) => ({
          ...l,
          // If the substitute is not present in the new list we also remove it from the lesson
          selectedSubstitute: (value ?? []).some(
            (s) => s.id === l.selectedSubstitute?.id,
          )
            ? l.selectedSubstitute
            : undefined,
        })),
      ),
    );
  };

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex-grow space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Bereits organisierte Vertretungen
        </h2>
        {
          <VacancySubstituteSelectionCombobox
            value={substitutes}
            onSetSubstitutes={onSetSubstitutes}
          />
        }
        {schedule && !!substitutes?.length && (
          <SubstituteScheduler
            className="m-auto md:max-w-[75%] xl:max-w-[50%]"
            startDate={new Date(dates[0])}
            schedule={schedule}
            substitutes={substitutes ?? []}
            setValue={setLessons}
            lessons={lessons}
            disableDefaultScheduler={true}
            absentTeacher={absentTeacher}
          />
        )}
      </div>
    </div>
  );
}

export default SubstitutesStep;
